// extracted by mini-css-extract-plugin
module.exports = {"columnText":"tableHead_columnText__1_NQ0"};